import { gql } from "@apollo/client";

export const SEARCH_PUBLIC_WORKER_POOL_USED_BY = gql`
  query SearchPublicWorkerPoolUsedBy($input: SearchInput!) {
    publicWorkerPool {
      usersCount
      searchUsers(input: $input) {
        edges {
          cursor
          node {
            stackId
            stackName
            isModule
            spaceDetails {
              id
              name
              accessLevel
            }
          }
        }
        pageInfo {
          hasNextPage
          endCursor
        }
      }
    }
  }
`;

export const SEARCH_PUBLIC_WORKER_POOL_USED_BY_SUGGESTIONS = gql`
  query SearchPublicWorkerPoolUsedBySuggestions($input: SearchSuggestionsInput!) {
    publicWorkerPool {
      usersCount
      searchUsersSuggestions(input: $input) {
        filteredCount
        fields {
          name
          orderable
        }
      }
    }
  }
`;
